import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { ReactElement, ReactNode } from 'react';
import { reactPlugin } from '../appInsights';

export interface ITelemetryProviderProps {
	children?: ReactNode;
}

export function TelemetryProviderWrapper(
	props: ITelemetryProviderProps
): ReactElement {
	const { children } = props;

	return (
		<AppInsightsContext.Provider value={reactPlugin}>
			{children}
		</AppInsightsContext.Provider>
	);
}
